import { skipToken, useQuery } from "@tanstack/react-query";
import { getMerchantsPublicIDOrbitLHunterTerminals } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const HUNTER_TERMINALS_FOR_RESERVATION_KEY = "HUNTER_TERMINALS_FOR_RESERVATION";

export const hunterTerminalsForReservationKeys = {
  all: [HUNTER_TERMINALS_FOR_RESERVATION_KEY],
  byMerchantPublicId: (merchantPublicID?: string) => [
    ...hunterTerminalsForReservationKeys.all,
    merchantPublicID,
  ],
  byMerchantAndFacility: (
    merchantPublicID?: string,
    facilityPublicID?: string | null,
  ) => [
    ...hunterTerminalsForReservationKeys.byMerchantPublicId(merchantPublicID),
    facilityPublicID,
  ],
};

export const useGetHunterTerminalsForReservationQuery = (
  merchantPublicID?: string,
  facilityPublicID?: string | null,
  enabled = true,
) =>
  useQuery({
    queryKey: hunterTerminalsForReservationKeys.byMerchantAndFacility(
      merchantPublicID,
      facilityPublicID,
    ),
    queryFn: merchantPublicID
      ? processResponseWithApiProblemDetails(() =>
          getMerchantsPublicIDOrbitLHunterTerminals(
            merchantPublicID,
            facilityPublicID ?? undefined,
          ),
        )
      : skipToken,
    enabled,
  });
